import {
  type Channel,
  type HouseholderCommonPage,
  ProductType,
} from "@/api_client";
import { HouseholderEntryForm } from "@/components/products/householder/entry/HouseholderEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import type { Locales } from "@/graphql/generated";
import { useEntryContentExternal } from "@/services/cms/tanstackQuery/hooks/useEntryContentExternal";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type HouseholderEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function HouseholderEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<HouseholderEntryProps>) {
  const {
    isLoading,
    isSubmitting,
    submitEntryHandler,
    policyHolder,
    user,
    commonContent,
  } = useEntryForWebComponents<HouseholderCommonPage>({
    productType: "householder",
    backendHost,
    appPathPrefix,
    skipCart,
    channel,
    commonContentPageKey: "householderCommonPage",
    language,
  });

  const { data: content, isLoading: isLoadingContent } =
    useEntryContentExternal({
      product: ProductType.HOUSEHOLDER,
      language: language as Locales,
      appPathPrefix,
    });

  if (isLoading || isLoadingContent) return <ProductContainer.Loader />;

  return (
    <HouseholderEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
      externalCommonContent={commonContent}
    />
  );
}
